import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'FilledStarIcon',
  'filled-star',
  'M458.298 840.753c23.409 42.136 84.007 42.136 107.416 0l106.040-190.872 210.903-21.090c48.092-4.809 72.059-60.703 42.383-98.855l-152.105-195.563 63.739-233.702c14.249-52.244-41.155-96.036-88.694-70.103l-235.976 128.712-235.973-128.712c-47.54-25.933-102.944 17.859-88.695 70.103l63.737 233.702-152.103 195.563c-29.674 38.153-5.709 94.046 42.384 98.855l210.903 21.090 106.040 190.872z',
)
